export {default} from 'netxcore@netx/core-app/controller';

////////////////////////////////////
// Deferred module loaders
////////////////////////////////////
// These are all core defined deferred modules
// If themes choose to create new deferred module they will need to set up their own dispatchers and routes accordingly
// and in the same pattern as seen here
// These are placed here for optimal bundle creations.
/**
 * @event module:netx#netx:load:module:adBuilder
 * @param {object} opts Options
 * @fires module:netx#netx:load:module
 */
dispatcher.on('netx:load:module:adBuilder', function (opts) {
	import(
		/* webpackChunkName: "@netx/core-ad-builder" */ '@netx/core-ad-builder'
	).then((AdBuilder) => {
		dispatcher.trigger('netx:load:deferred:module', AdBuilder.default, opts);
	});
});

/**
 * @event module:netx#netx:load:module:attribute:metadata:map
 * @param {object} opts Options
 * @fires module:netx#netx:load:module
 */
dispatcher.on('netx:load:module:attribute:metadata:map', function (opts) {
	import(
		/* webpackChunkName: "@netx/core-attribute-metadata-map" */ '@netx/core-attribute-metadata-map'
	).then((MetadataMap) => {
		dispatcher.trigger('netx:load:deferred:module', MetadataMap.default, opts);
	});
});

/**
 * @event module:netx#netx:load:module:system:caches
 * @param {object} opts Options
 * @fires module:netx#netx:load:module
 */
dispatcher.on('netx:load:module:attribute:set:user', function (opts) {
	import(
		/* webpackChunkName: "@netx/core-attribute-set-user" */ '@netx/core-attribute-set-user'
	).then((AttributeUserSet) => {
		dispatcher.trigger(
			'netx:load:deferred:module',
			AttributeUserSet.default,
			opts,
		);
	});
});
/**
 * @event module:netx#netx:load:module:audioeditor
 * @param {object} opts Options
 * @fires module:netx#netx:load:module
 */
dispatcher.on('netx:load:module:audioeditor', function (opts) {
	import(
		/* webpackChunkName: "@netx/core-audio-editor" */ '@netx/core-audio-editor'
	).then((AudioEditor) => {
		dispatcher.trigger('netx:load:deferred:module', AudioEditor.default, opts);
	});
});
/**
 * @event module:netx#netx:load:module:dataset
 * @param {object} opts Options
 * @fires module:netx#netx:load:module
 */
dispatcher.on('netx:load:module:dataset', function (opts, cb) {
	import(
		/* webpackChunkName: "@netx/core-data-set" */ '@netx/core-data-set'
	).then((DataSet) => {
		dispatcher.trigger('netx:load:deferred:module', DataSet.default, opts);
	});
});
/**
 * @event module:netx#netx:load:module:pdfViewer
 * @param {object} opts Options
 * @fires module:netx#netx:load:module
 */
dispatcher.on('netx:load:module:pdfViewer', function (opts, cb) {
	import(
		/* webpackChunkName: "@netx/core-pdf-viewer" */ '@netx/core-pdf-viewer'
	).then((PDFViewer) => {
		dispatcher.trigger('netx:load:deferred:module', PDFViewer.default, opts);
	});
});
/**
 * @event module:netx#netx:load:module:imageeditor
 * @param {object} opts Options
 * @fires module:netx#netx:load:module
 */
dispatcher.on('netx:load:module:imageeditor', function (opts, cb) {
	import(
		/* webpackChunkName: "@netx/core-image-editor" */ '@netx/core-image-editor'
	).then((ImageEditor) => {
		dispatcher.trigger('netx:load:deferred:module', ImageEditor.default, opts);
	});
});
/**
 * @event module:netx#netx:load:module:project
 * @param {object} opts Options
 * @fires module:netx#netx:load:module
 */
dispatcher.on('netx:load:module:project', function (opts, cb) {
	import(
		/* webpackChunkName: "@netx/core-project" */ '@netx/core-project'
	).then((Project) => {
		dispatcher.trigger('netx:load:deferred:module', Project.default, opts);
	});
});
/**
 * @event module:netx#netx:load:module:stat
 * @param {object} opts Options
 * @fires module:netx#netx:load:module
 */
dispatcher.on('netx:load:module:stat', function (opts, cb) {
	import(
		/* webpackChunkName: "@netx/core-stat-next" */ '@netx/core-stat-next'
	).then((Stat) => {
		dispatcher.trigger('netx:load:deferred:module', Stat.default, opts);
	});
});
/**
 * @event module:netx#netx:load:module:system
 * @param {object} opts Options
 * @fires module:netx#netx:load:module
 */
dispatcher.on('netx:load:module:system', function (opts, cb) {
	import(/* webpackChunkName: "@netx/core-system" */ '@netx/core-system').then(
		(System) => {
			dispatcher.trigger('netx:load:deferred:module', System.default, opts);
		},
	);
});
/**
 * @event module:netx#netx:load:module:attribute:vocabulary
 * @param {object} opts Options
 * @fires module:netx#netx:load:module
 */
dispatcher.on('netx:load:module:attribute:vocabulary', function (opts) {
	import(
		/* webpackChunkName: "@netx/core-attribute-vocabulary" */ '@netx/core-attribute-vocabulary'
	).then((AttributeVocabulary) => {
		dispatcher.trigger(
			'netx:load:deferred:module',
			AttributeVocabulary.default,
			opts,
		);
	});
});
/**
 * @event module:netx#netx:load:module:system:caches
 * @param {object} opts Options
 * @fires module:netx#netx:load:module
 */
dispatcher.on('netx:load:module:system:caches', function (opts) {
	import(
		/* webpackChunkName: "@netx/core-system-cache" */ '@netx/core-system-cache'
	).then((SystemCache) => {
		dispatcher.trigger('netx:load:deferred:module', SystemCache.default, opts);
	});
});
/**
 * @event module:netx#netx:load:module:system:groups
 * @param {object} opts Options
 * @fires module:netx#netx:load:module
 */
dispatcher.on('netx:load:module:system:groups', function (opts) {
	import(
		/* webpackChunkName: "@netx/core-system-groups" */ '@netx/core-system-groups'
	).then((SystemGroups) => {
		dispatcher.trigger('netx:load:deferred:module', SystemGroups.default, opts);
	});
});
/**
 * @event module:netx#netx:load:module:system:indexes
 * @param {object} opts Options
 * @fires module:netx#netx:load:module
 */
dispatcher.on('netx:load:module:system:indexes', function (opts) {
	import(
		/* webpackChunkName: "@netx/core-system-indexes" */ '@netx/core-system-index'
	).then((SystemIndexes) => {
		dispatcher.trigger(
			'netx:load:deferred:module',
			SystemIndexes.default,
			opts,
		);
	});
});
/**
 * @event module:netx#netx:load:module:system:logs
 * @param {object} opts Options
 * @fires module:netx#netx:load:module
 */
dispatcher.on('netx:load:module:system:logs', function (opts) {
	import(
		/* webpackChunkName: "@netx/core-system-log" */ '@netx/core-system-log'
	).then((SystemLog) => {
		dispatcher.trigger('netx:load:deferred:module', SystemLog.default, opts);
	});
});
/**
 * @event module:netx#netx:load:module:system:overview
 * @param {object} opts Options
 * @fires module:netx#netx:load:module
 */
dispatcher.on('netx:load:module:system:overview', function (opts) {
	import(
		/* webpackChunkName: "@netx/core-system-overview" */ '@netx/core-system-overview'
	).then((SystemOverview) => {
		dispatcher.trigger(
			'netx:load:deferred:module',
			SystemOverview.default,
			opts,
		);
	});
});
/**
 * @event module:netx#netx:load:module:system:portals
 * @param {object} opts Options
 * @fires module:netx#netx:load:module
 */
dispatcher.on('netx:load:module:system:portals', function (opts) {
	import(
		/* webpackChunkName: "@netx/core-cms-next" */ '@netx/core-cms-next'
	).then((SystemPortals) => {
		dispatcher.trigger(
			'netx:load:deferred:module',
			SystemPortals.default,
			opts,
		);
	});
});

/*
 * @event module:netx#netx:load:module:system:property
 * @param {object} opts Options
 * @fires module:netx#netx:load:module
 */
dispatcher.on('netx:load:module:system:property', function (opts) {
	import(
		/* webpackChunkName: "@netx/core-system-property" */ '@netx/core-system-property'
	).then((SystemProperty) => {
		dispatcher.trigger(
			'netx:load:deferred:module',
			SystemProperty.default,
			opts,
		);
	});
});

/**
 * @event module:netx#netx:load:module:videoeditor
 * @param {object} opts Options
 * @fires module:netx#netx:load:module
 */
dispatcher.on('netx:load:module:videoeditor', function (opts, cb) {
	import(
		/* webpackChunkName: "@netx/core-video-editor" */ '@netx/core-video-editor'
	).then((VideoEditor) => {
		dispatcher.trigger('netx:load:deferred:module', VideoEditor.default, opts);
	});
});

/**
 * @event module:netx#netx:load:module:uploadAssetRequestManager
 * @param {object} opts Options
 * @fires module:netx#netx:load:module
 */
dispatcher.on('netx:load:module:uploadAssetRequestManager', function (opts) {
	import(
		/* webpackChunkName: "@netx/core-upload-asset-request-manager" */ '@netx/core-upload-asset-request-manager'
	).then((UploadAssetRequestManager) => {
		dispatcher.trigger(
			'netx:load:deferred:module',
			UploadAssetRequestManager.default,
			opts,
		);
	});
});

/**
 * @event module:netx#netx:load:module:user:integrations
 * @param {object} opts Options
 * @fires module:netx#netx:load:module
 */
dispatcher.on('netx:load:module:user:integrations', function (opts) {
	import(
		/* webpackChunkName: "@netx/core-user-integrations" */ '@netx/core-user-integrations'
	).then((UserIntegrations) => {
		dispatcher.trigger(
			'netx:load:deferred:module',
			UserIntegrations.default,
			opts,
		);
	});
});

////////////////////////////////////
// !Deferred module loaders
////////////////////////////////////

/**
 * App Module Extensions
 * @event module:app#app:extend
 */
dispatcher.once('app:extend', function (NS) {
	/**
	 * @event module:netx#routed
	 */
	dispatcher.on('routed', function () {
		// Kills things (like dropdowns and the like)
		NS.$body.click();
	});

	////////////////////////////
	// Drag Events
	////////////////////////////
	// For the love of bubbling events
	// Prevent the browser from trying to interpret these things
	NS.$document
		.off('dragover')
		// Bubbles up from drop zones within
		.on('dragover', 'body', function (e) {
			// Prevent
			e.preventDefault();
			return false;
		})
		// Bubbles up from drop zones within
		.off('drop')
		.on('drop', 'body', function (e) {
			// Prevent
			e.preventDefault();
			return false;
		});
}); // app:extend
